<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1></h1>
        <span class="pull-right icon-right orange" @click="sendImgs()">发送</span>
      </div>
      <div class="liner"></div>
    </div>



    <div class="main-page">

        <ul class="list-group-item tinny">
          <li class="list-group">
            <div class="liner"></div>
            <a class="clearfix group-txt img-more" @click.prevent="isHideSelectStudent = false">
              <span class="pull-left">学生：</span><i class="red must">*</i>
              <span class="pull-right margin-x-15 gray font-12">{{studentInfo.studentName ? studentInfo.studentName : '选择学生'}}</span>
            </a>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <label class="clearfix group-txt img-more forselect" for="kemu">
              <span class="pull-left">科目：</span><i class="red must">*</i>
              <span class="pull-right margin-x-15 gray font-12" @click="isHideSubject = false">{{subject ? subject: '选择科目'}}</span>
              <!-- <span class="selectbar">
                <select id="kemu" v-model="subject">
                  <option :value="subject.subjectName" v-for="subject in subjectList">{{subject.subjectName}}</option>
                </select>
              </span> -->
            </label>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">成绩名目：</span><i class="red must pull-left">*</i>
              <span class="block gray" style="margin-left:100px"><input v-model="testName" class="text-right font-12" style="width:100%" type="text" placeholder="如：第二单元测验"></span>
            </div>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">成绩：</span><i class="red must">*</i>
              <span class="pull-right gray"><input v-model="score" class="text-right font-12" type="text" placeholder="填写成绩"></span>
            </div>
          </li>
        </ul>

      <div class="padding-15 bg-white">
        <textarea class="font-14" width="100%" rows="5" placeholder="输入您的评价，您的鼓励是孩子进步的动力！" v-model="content"></textarea>
        <div class="add-pic">
          <ul class="list-group-item clearfix">
            <li v-for="(image, index) in imagesList">
              <!-- <div>
                <img :src="image.baseAcessPath + image.thumb" width="80" height="80"/><span class="del" v-tap="delImage(index)">删除</span>
              </div> -->
              <div @click="index = index, isHideImg = false, imageSrc = image.baseAcessPath + image.thumb">
                <img :src="image.baseAcessPath + image.thumb" width="80" height="80"/>
              </div>
            </li>
            <li v-if="imagesList.length < 6">
              <div class="button-add" @click="capturePhoto();" v-if="isAndroid"></div>
              <div class="button-add" v-else>
                <form enctype="multipart/form-data" method="post" name="fileinfo">
                  <input type="file" name="pic" id="pic" accept="image/*" multiple="multiple" @change="updateImage()"/>
                </form>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 选择学生 -->
    <dialogStudents :isHideSelectStudent="isHideSelectStudent" :studentFirstCharList="studentFirstCharList" v-on:close="closeDialogStudents" v-on:selected="selectedStudent"></dialogStudents>

    <div class="main-page" v-if="!isHideImg">
      <div class="topbar">
        <div class="clearfix main-wrap">
          <a class="pull-left img-back" @click.prevent="isHideImg = true">返回</a>
          <h1></h1>
          <span class="pull-right icon-right orange" @click="isHideDelImage = false">删除</span>
        </div>
        <div class="liner"></div>
      </div>

      <div class="bg-white" @click="isHideImg = true">
        <img class="mid-align" :src="imageSrc" width="100%" />
      </div>
    </div>

    <!-- 删除图片 -->
    <div class="maskdiv" v-if="!isHideDelImage">
      <div class="bottom-block text-center" style="background:none">
        <ul class="list-group-item  tinny">
          <li class="list-group">
            <div class="liner"></div>
            <a class="group-txt" @click.prevent="delImage()"><span class="orange block font-16">删除</span></a>
          </li>
        </ul>
        <ul class="list-group-item tinny" style="margin:0">
          <li class="list-group">
            <div class="liner"></div>
            <a class="group-txt" @click.prevent="isHideDelImage = true"><span class="block font-16">取消</span></a>
          </li>
        </ul>
      </div>
    </div>

    <!-- 选择科目 -->
    <div class="maskdiv" v-show="!isHideSubject" @click="isHideSubject = true">
      <div class="slider">
        <strong class="tit">选择科目</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in subjectList">
            <li @click="subject = item.subjectName, isHideSubject = true">
              <div class="clearfix group-link"><span class="pull-left">{{item.subjectName}}</span>
              <template v-if="item.subjectName == subject">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              </div>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { service, uploadMulUrl } from '../../service'
import { mapGetters, mapMutations } from 'vuex'
// component
import dialogStudents from '../../components/student/dialogStudents'

export default {
  computed: mapGetters({
    studentFirstCharList: 'getStudentsByFirstChar'
  }),
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      login_data: JSON.parse(window.localStorage['login_data']),
      curcheId: 0,
      teacherId: 0,
      content: '',
      subject: '',
      testName: '',
      score: '',
      imagesList: [],
      // studentList: [],
      subjectList: [],
      isHideSelectStudent: true,
      studentInfo: {},
      insert_score_para: service.setPara('toSendCj'),
      get_new_student_list_para: service.setPara('getNewStudentList'),
      tsubject_list_para: service.setPara('tsubjectList'),
      isPublishing: false,
      isHideImg: true,
      isHideDelImage: true,
      index: 0,
      imageSrc: '',
      fileList: [],
      isAndroid: true,
      isHideSubject: true
    }
  },
  components: {
    dialogStudents
  },
  mounted: function () {
    let b = window.browser()
    this.isAndroid = b.android

    this.curcheId = this.cookie_login_data.curcheId
    this.teacherId = this.cookie_login_data.teacherId

    this.get_new_student_list_para.curcheId = this.curcheId
    this.get_new_student_list_para.sfzt = '在托'
    this.get_new_student_list_para.context = this

    this.tsubjectList()
    this.getStuList()

    // $('div.maskdiv,div.maskdiv div.slider').css('height', $(window).height())
  },
  methods: {
    ...mapMutations([
      'receiveStudents'
    ]),
    tsubjectList: function () {
      this.tsubject_list_para.curcheId = this.curcheId
      let that = this
      let obj = {context: this, para: this.tsubject_list_para, successFun: (response) => {
        that.subjectList = response.data
      }}
      service.request(obj)
    },
    getStuList: function () {
      this.$store.dispatch('receiveStudents', this.get_new_student_list_para)
    },
    insertScore: function () {
      if (!this.studentInfo.studentName) {
        Toast('请选择学生')
        return
      }

      if ($.trim(this.subject) == '') {
        Toast('请选择科目')
        return
      }

      if ($.trim(this.testName) == '') {
        Toast('请填写测试名目')
        return
      }

      if ($.trim(this.score) == '') {
        Toast('请填写成绩')
        return
      }

      if (this.isPublishing) {
        return
      } else {
        this.isPublishing = true
      }

      this.insert_score_para.teacherId = this.teacherId
      this.insert_score_para.curcheId = this.curcheId
      this.insert_score_para.content = $.trim(this.content)
      this.insert_score_para.studentId = this.studentInfo.studentId
      this.insert_score_para.imageList = this.imagesList
      this.insert_score_para.score = $.trim(this.score)
      this.insert_score_para.testName = $.trim(this.testName)
      this.insert_score_para.subject = $.trim(this.subject)
      Indicator.open('发布中...')

      let that = this
      let obj = {context: this, para: this.insert_score_para, successFun: (response) => {
        that.insert_score_para.scoreId = response.data
        that.saveImgTolocalStorage(that.insert_score_para)
        window.history.go(-1)
      }}
      service.request(obj)
    },
    updateImage: function () {
      let nl = 0
      let files = document.getElementById('pic').files
      if (files.length === 0) {
        return
      }

      if (files.length + this.imagesList.length > 6) {
        Toast('最多只能再上传' + (6 - this.imagesList.length) + '张图片')
        return
      }

      for (let i = 0; i < files.length; i++) {
        Indicator.open()
        lrz(files[i], {width: 1024})
        .then((rst) => {
          nl++
          let imageInfo = {}
          imageInfo.baseAcessPath = rst.base64
          imageInfo.image = ''
          imageInfo.thumb = ''
          imageInfo.fileName = rst.origin.name
          this.imagesList.push(imageInfo)
          let f = {}
          f.file = rst.file
          f.name = rst.origin.name
          this.fileList.push(f)
          if (nl == files.length) {
            Indicator.close()
          }
        })
      }
    },
    delImage: function (index) {
      // this.imagesList.splice(index, 1)
      this.imagesList.splice(this.index, 1)
      this.fileList.splice(this.index, 1)
      this.isHideDelImage = true
      this.isHideImg = true
    },
    sendImgs: function () {
      let data = new window.FormData()

      for (let i = 0; i < this.fileList.length; i++) {
        data.append('pic', this.fileList[i].file, this.fileList[i].name)
      }

      let url = uploadMulUrl + this.cookie_login_data.phoneNum + '&needThumb=1'

      let that = this
      let obj = {context: this, para: data, url: url, successFun: (response) => {
        that.imagesList = []
        for (var i = 0; i < response.data.length; i++) {
          var imageInfo = {}
          imageInfo.baseAcessPath = response.data[i].image.baseAcessPath
          imageInfo.image = response.data[i].image.srcFilePath
          imageInfo.thumb = response.data[i].image.thumbFilePath
          that.imagesList.push(imageInfo)
        }
        console.log('图片处理完成')
        that.insertScore()
      }}
      service.request(obj)
    },
    saveImgTolocalStorage: function (para) { // 保存图片信息到本地，便于快速读取
      var item = {}
      item.content = para.content
      item.publishDate = new Date().getTime()
      item.teacherId = para.teacherId
      item.teacherName = this.login_data[this.cookie_login_data.index].teacherName
      item.teacher_icon = this.login_data[this.cookie_login_data.index].teacherIcon

      item.studentId = para.studentId
      // item.studentName = para.studentName
      item.studentName = this.studentInfo.studentName
      item.testName = para.testName

      item.score = para.score
      item.subject = para.subject
      item.scoreId = para.scoreId

      item.isUploadOver = false
      item.baseAcessPath = this.cookie_login_data.baseAcessPath
      item.field2 = this.studentInfo.imageAddress
      var imgs = []
      for (var i = 0; i < this.imagesList.length; i++) {
        var img = {}
        img.baseAcessPath = this.imagesList[i].baseAcessPath
        img.imageAddress = this.imagesList[i].image
        img.thumbAddress = this.imagesList[i].thumb
        imgs.push(img)
      }
      item.picList = imgs
      window.localStorage['score_new'] = JSON.stringify(item)
    },
    capturePhoto: function () {
      Indicator.open()
      navigator.camera.getPicture(this.onPhotoDataSuccess, this.onFail, { quality: 50, destinationType: navigator.camera.DestinationType.DATA_URL, sourceType: navigator.camera.PictureSourceType.PHOTOLIBRARY, targetWidth: 1000, targetHeight: 2000 })
    },
    onPhotoDataSuccess: function (imageData) {
      let imageInfo = {}
      imageInfo.baseAcessPath = 'data:image/jpeg;base64,' + imageData
      imageInfo.image = ''
      imageInfo.thumb = ''
      this.imagesList.push(imageInfo)
      let f = {}
      f.file = this.dataURLtoBlob(imageInfo.baseAcessPath)
      f.name = this.fileList.length + '.png'
      this.fileList.push(f)
      Indicator.close()
    },
    onFail: function (message) {
      Indicator.close()
      // alert('Failed because: ' + message)
    },
    dataURLtoBlob: function (dataurl) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = window.atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new window.Blob([u8arr], {type: mime})
    },
    closeDialogStudents () { // 关闭选择学生弹出框
      this.isHideSelectStudent = true
    },
    selectedStudent (student) {
      this.studentInfo = student
      this.isHideSelectStudent = true
    }
  }
}
</script>
<style scoped>
  .list-group-item.primary{padding-right:32px;}
</style>



// WEBPACK FOOTER //
// scorePublish.vue?c9f948cc